import { groupByTypes, orderByTypes } from 'lib/services/cart/cart-order'
import CartItem from 'components/Teasers/CartItem'
import styles from './CartItems.module.scss'

export default function CartItems({ items, removeItem }) {
  const itemGroups = orderByTypes(groupByTypes(items))

  return (
    <div className="container">
      {itemGroups.map(({ title, items: groupItems }, index) => (
        <div key={index}>
          <h2
            className={`${styles.title} h6`}
          >{`${title} (${groupItems.length})`}</h2>
          {groupItems.map((item) => (
            <CartItem key={item.id} item={item} removeItem={removeItem} />
          ))}
        </div>
      ))}
    </div>
  )
}
